import React from "react";
import { t } from "@lingui/macro";

const InvoiceForm = ({ receiver, setReceiver }) => {
  const fieldStyle = {
    display: "flex",
    marginBottom: "0.5rem",
    alignItems: "center",
  };

  const labelStyle = {
    width: "150px",
    fontWeight: "bold",
    marginRight: "1rem",
  };

  const inputStyle = {
    flex: 1,
    padding: "0.3rem 0.5rem",
    border: "1px solid #ccc",
    borderRadius: "4px",
  };

  return (
    <div style={{ marginTop: "1rem", border: "1px solid #ccc", padding: "1rem" }}>
      <h3>{t`Receiver Data`}</h3>

      <div style={fieldStyle}>
        <label style={labelStyle}>{t`Name / Business Name`}:</label>
        <input
          style={inputStyle}
          type="text"
          placeholder={t`e.g. Juan Pérez`}
          value={receiver.name}
          onChange={(e) => setReceiver({ ...receiver, name: e.target.value })}
        />
      </div>

      <div style={fieldStyle}>
        <label style={labelStyle}>RFC:</label>
        <input
          style={inputStyle}
          type="text"
          placeholder={t`e.g. ABC123456XXX`}
          value={receiver.rfc}
          onChange={(e) => setReceiver({ ...receiver, rfc: e.target.value })}
        />
      </div>

      <div style={fieldStyle}>
        <label style={labelStyle}>{t`CFDI Use`}:</label>
        <input
          style={inputStyle}
          type="text"
          placeholder={t`e.g. S01`}
          value={receiver.cfdiUse}
          onChange={(e) =>
            setReceiver({ ...receiver, cfdiUse: e.target.value })
          }
        />
      </div>

      <div style={fieldStyle}>
        <label style={labelStyle}>{t`Fiscal Regime`}:</label>
        <input
          style={inputStyle}
          type="text"
          placeholder={t`e.g. 616`}
          value={receiver.fiscalRegime}
          onChange={(e) =>
            setReceiver({ ...receiver, fiscalRegime: e.target.value })
          }
        />
      </div>

      <div style={fieldStyle}>
        <label style={labelStyle}>{t`Postal Code`}:</label>
        <input
          style={inputStyle}
          type="text"
          placeholder={t`e.g. 12345`}
          value={receiver.taxZipCode}
          onChange={(e) =>
            setReceiver({ ...receiver, taxZipCode: e.target.value })
          }
        />
      </div>
    </div>
  );
};

export default InvoiceForm;
